import CONSTANTS from "../constants.js";
export default {
    SYSTEM_ID: "dnd5e",
    /**
     * based on https://github.com/game-icons/icons/issues/516
     */
    imageReplacerDamageType: [
        { name: "DND5E.DamageAcid", icon: `modules/${CONSTANTS.MODULE_ID}/assets/acid.svg` },
        { name: "DND5E.DamageBludgeoning", icon: `modules/${CONSTANTS.MODULE_ID}/assets/bludgeoning.svg` },
        { name: "DND5E.DamageCold", icon: `modules/${CONSTANTS.MODULE_ID}/assets/cold.svg` },
        { name: "DND5E.DamageFire", icon: `modules/${CONSTANTS.MODULE_ID}/assets/fire.svg` },
        { name: "DND5E.DamageForce", icon: `modules/${CONSTANTS.MODULE_ID}/assets/force.svg` },
        { name: "DND5E.DamageLightning", icon: `modules/${CONSTANTS.MODULE_ID}/assets/lightning.svg` },
        { name: "DND5E.DamageNecrotic", icon: `modules/${CONSTANTS.MODULE_ID}/assets/necrotic.svg` },
        { name: "DND5E.DamagePiercing", icon: `modules/${CONSTANTS.MODULE_ID}/assets/piercing.svg` },
        { name: "DND5E.DamagePhysical", icon: `modules/${CONSTANTS.MODULE_ID}/assets/non_magical_physical.svg` },
        { name: "DND5E.DamagePoison", icon: `modules/${CONSTANTS.MODULE_ID}/assets/poison.svg` },
        { name: "DND5E.DamagePsychic", icon: `modules/${CONSTANTS.MODULE_ID}/assets/psychic.svg` },
        { name: "DND5E.DamageRadiant", icon: `modules/${CONSTANTS.MODULE_ID}/assets/radiant.svg` },
        { name: "DND5E.DamageSlashing", icon: `modules/${CONSTANTS.MODULE_ID}/assets/slashing.svg` },
        { name: "DND5E.DamageThunder", icon: `modules/${CONSTANTS.MODULE_ID}/assets/thunder.svg` },
    ],
    imageReplacerWeaponProperties: [
        { name: "DND5E.WeaponPropertiesAda", icon: `modules/${CONSTANTS.MODULE_ID}/assets/adamantine.svg` },
        { name: "DND5E.WeaponPropertiesAmm", icon: `modules/${CONSTANTS.MODULE_ID}/assets/ammunition.svg` },
        { name: "DND5E.WeaponPropertiesFin", icon: `modules/${CONSTANTS.MODULE_ID}/assets/finesse.svg` },
        { name: "DND5E.WeaponPropertiesFir", icon: `modules/${CONSTANTS.MODULE_ID}/assets/firearm.svg` },
        { name: "DND5E.WeaponPropertiesFoc", icon: `modules/${CONSTANTS.MODULE_ID}/assets/focus.svg` },
        { name: "DND5E.WeaponPropertiesHvy", icon: `modules/${CONSTANTS.MODULE_ID}/assets/heavy.svg` },
        { name: "DND5E.WeaponPropertiesLgt", icon: `modules/${CONSTANTS.MODULE_ID}/assets/light.svg` },
        { name: "DND5E.WeaponPropertiesLod", icon: `modules/${CONSTANTS.MODULE_ID}/assets/loading.svg` },
        { name: "DND5E.WeaponPropertiesMgc", icon: `modules/${CONSTANTS.MODULE_ID}/assets/magical.svg` },
        { name: "DND5E.WeaponPropertiesRch", icon: `modules/${CONSTANTS.MODULE_ID}/assets/reach.svg` },
        { name: "DND5E.WeaponPropertiesRel", icon: `modules/${CONSTANTS.MODULE_ID}/assets/reload.svg` },
        { name: "DND5E.WeaponPropertiesRet", icon: `modules/${CONSTANTS.MODULE_ID}/assets/returning.svg` },
        { name: "DND5E.WeaponPropertiesSil", icon: `modules/${CONSTANTS.MODULE_ID}/assets/silvered.svg` },
        { name: "DND5E.WeaponPropertiesSpc", icon: `modules/${CONSTANTS.MODULE_ID}/assets/special.svg` },
        { name: "DND5E.WeaponPropertiesThr", icon: `modules/${CONSTANTS.MODULE_ID}/assets/thrown.svg` },
        { name: "DND5E.WeaponPropertiesTwo", icon: `modules/${CONSTANTS.MODULE_ID}/assets/two-Handed.svg` },
        { name: "DND5E.WeaponPropertiesVer", icon: `modules/${CONSTANTS.MODULE_ID}/assets/versatile.svg` },
    ],
    /**
     * based on https://github.com/game-icons/icons/issues/516
     */
    imageReplacerIconizer: [
        // =======================================================================
        // dnd5e
        // =======================================================================
        { name: "DND5E.DamageRoll", icon: `modules/${CONSTANTS.MODULE_ID}/assets/damage_roll.svg` },
        { name: "DND5E.AttackRoll", icon: `modules/${CONSTANTS.MODULE_ID}/assets/attack_roll.svg` },
        { name: "DND5E.SkillAcr", icon: `modules/${CONSTANTS.MODULE_ID}/assets/acrobatics.svg` },
        { name: "DND5E.SkillAni", icon: `modules/${CONSTANTS.MODULE_ID}/assets/animal_handling.svg` },
        { name: "DND5E.SkillArc", icon: `modules/${CONSTANTS.MODULE_ID}/assets/arcana.svg` },
        { name: "DND5E.SkillAth", icon: `modules/${CONSTANTS.MODULE_ID}/assets/athletics.svg` },
        { name: "DND5E.SkillDec", icon: `modules/${CONSTANTS.MODULE_ID}/assets/deception.svg` },
        { name: "DND5E.SkillHis", icon: `modules/${CONSTANTS.MODULE_ID}/assets/history.svg` },
        { name: "DND5E.SkillIns", icon: `modules/${CONSTANTS.MODULE_ID}/assets/insight.svg` },
        { name: "DND5E.SkillItm", icon: `modules/${CONSTANTS.MODULE_ID}/assets/intimidation.svg` },
        { name: "DND5E.SkillInv", icon: `modules/${CONSTANTS.MODULE_ID}/assets/investigation.svg` },
        { name: "DND5E.SkillMed", icon: `modules/${CONSTANTS.MODULE_ID}/assets/medicine.svg` },
        { name: "DND5E.SkillNat", icon: `modules/${CONSTANTS.MODULE_ID}/assets/nature.svg` },
        { name: "DND5E.SkillPrc", icon: `modules/${CONSTANTS.MODULE_ID}/assets/perception.svg` },
        { name: "DND5E.SkillPrf", icon: `modules/${CONSTANTS.MODULE_ID}/assets/performance.svg` },
        { name: "DND5E.SkillPer", icon: `modules/${CONSTANTS.MODULE_ID}/assets/persuasion.svg` },
        { name: "DND5E.SkillRel", icon: `modules/${CONSTANTS.MODULE_ID}/assets/religion.svg` },
        { name: "DND5E.SkillSlt", icon: `modules/${CONSTANTS.MODULE_ID}/assets/sleight_of_hand.svg` },
        { name: "DND5E.SkillSte", icon: `modules/${CONSTANTS.MODULE_ID}/assets/stealth.svg` },
        { name: "DND5E.SkillSur", icon: `modules/${CONSTANTS.MODULE_ID}/assets/survival.svg` },
        { name: "DND5E.ToolArtisans", icon: `modules/${CONSTANTS.MODULE_ID}/assets/artisan_s_tools.svg` },
        { name: "DND5E.ToolDisguiseKit", icon: `modules/${CONSTANTS.MODULE_ID}/assets/disguise_kit.svg` },
        { name: "DND5E.ToolForgeryKit", icon: `modules/${CONSTANTS.MODULE_ID}/assets/forgery_kit` },
        { name: "DND5E.ToolGamingSet", icon: `modules/${CONSTANTS.MODULE_ID}/assets/gaming_set.svg` },
        { name: "DND5E.ToolHerbalismKit", icon: `modules/${CONSTANTS.MODULE_ID}/assets/herbalism_kit` },
        {
            name: "DND5E.ToolMusicalInstrument",
            icon: `modules/${CONSTANTS.MODULE_ID}/assets/musical_instrument.svg`,
        },
        { name: "DND5E.ToolNavigators", icon: `modules/${CONSTANTS.MODULE_ID}/assets/navigator_s_tools.svg` },
        { name: "DND5E.ToolPoisonersKit", icon: `modules/${CONSTANTS.MODULE_ID}/assets/poisoner_s_kit.svg` },
        { name: "DND5E.ToolThieves", icon: `modules/${CONSTANTS.MODULE_ID}/assets/thieves_tools.svg` },
        { name: "DND5E.ShortRest", icon: `modules/${CONSTANTS.MODULE_ID}/assets/short_rest.svg` },
        { name: "DND5E.LongRest", icon: `modules/${CONSTANTS.MODULE_ID}/assets/long_rest.svg` },
        { name: "DND5E.DeathSave", icon: `modules/${CONSTANTS.MODULE_ID}/assets/death_saves.svg` },
        { name: "DND5E.AbilityStr", icon: `modules/${CONSTANTS.MODULE_ID}/assets/strength.svg` },
        { name: "DND5E.AbilityDex", icon: `modules/${CONSTANTS.MODULE_ID}/assets/dexterity.svg` },
        { name: "DND5E.AbilityCon", icon: `modules/${CONSTANTS.MODULE_ID}/assets/constitution.svg` },
        { name: "DND5E.AbilityInt", icon: `modules/${CONSTANTS.MODULE_ID}/assets/intelligence.svg` },
        { name: "DND5E.AbilityWis", icon: `modules/${CONSTANTS.MODULE_ID}/assets/wisdom.svg` },
        { name: "DND5E.AbilityCha", icon: `modules/${CONSTANTS.MODULE_ID}/assets/charisma.svg` },
        { name: "DND5E.Initiative", icon: `modules/${CONSTANTS.MODULE_ID}/assets/initiative.svg` }, //https://game-icons.net/1x1/delapouite/acoustic-megaphone.html
        // TODO CONDITION I JUST DON'T KNOW HO CAN BE USEFUL
        // { name : 'DND5E.ConBlinded', icon : `Blinded",
        // { name : 'DND5E.ConCharmed', icon : `Charmed",
        // { name : 'DND5E.ConDeafened', icon : `Deafened",
        // { name : 'DND5E.ConDiseased', icon : `Diseased",
        // { name : 'DND5E.ConExhaustion', icon : `Exhaustion",
        // { name : 'DND5E.ConFrightened', icon : `Frightened",
        // { name : 'DND5E.ConGrappled', icon : `Grappled",
        // { name : 'DND5E.ConImm', icon : `Condition Immunities",
        // { name : 'DND5E.ConIncapacitated', icon : `Incapacitated",
        // { name : 'DND5E.ConInvisible', icon : `Invisible",
        // { name : 'DND5E.ConParalyzed', icon : `Paralyzed",
        // { name : 'DND5E.ConPetrified', icon : `Petrified",
        // { name : 'DND5E.ConPoisoned', icon : `Poisoned",
        // { name : 'DND5E.ConProne', icon : `Prone",
        // { name : 'DND5E.ConRestrained', icon : `Restrained",
        // { name : 'DND5E.ConStunned', icon : `Stunned",
        // { name : 'DND5E.ConUnconscious', icon : `Unconscious",
        // { name : 'DND5E.Concentration', icon : `Concentration",
    ],
};
